<template>
	<v-flowbox v-if="blok.key" :flowbox-key="blok.key" :tags="tags" />
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

const properties = defineProps<{
	blok: Extract<BlokComponent, {component: "sb-flowbox"}>;
}>();
const tags = properties.blok.tags
	? properties.blok.tags.split(" ").map((t) => t.trim())
	: undefined;
</script>
